<template>
  <div>
    <span class="text-center table-edit-icon" @click="showModal">
      <i class="text-center material-icons">edit</i>
    </span>
    <div class="centerx">
      <vs-popup
        :id="'popmodal' + params.data.payment_mode_id"
        class="holamundo editModal"
        title="Update Payment Mode"
        :active.sync="popupActive"
      >
        <form>
          <FocusLock>
            <div class="vx-row">
              <div class="col-12">
                <div class="vx-row mb-6">
                  <div
                    class="col-md-4 text-left md:text-right align-self-center"
                  >
                    <h5 class="mb-0">Logo</h5>
                  </div>
                  <div class="col-md-7 col-12">
                    <div class="text-center">
                      <label
                        for="updateProfilePicture"
                        class="position-relative mb-0"
                      >
                        <img
                          v-if="
                            form.payment_mode_icon &&
                              form.payment_mode_icon != '-'
                          "
                          :src="form.payment_mode_icon + '?token=' + temp_token"
                          class="profile-img"
                        />
                        <img v-else :src="ORG_LOGO" class="profile-img" />
                        <div class="comp-logo-update mt-2">
                          <i class="text-center material-icons align-middle"
                            >arrow_upward</i
                          >
                          update
                        </div>
                      </label>
                      <input
                        type="file"
                        @change="uploadFile($event)"
                        accept="image/*"
                        class="d-none"
                        id="updateProfilePicture"
                      />
                    </div>
                  </div>
                </div>
                <div class="vx-row mb-6">
                  <div
                    class="col-md-4 text-left md:text-right align-self-center"
                  >
                    <h5 class="mb-0">Payment Mode Name*</h5>
                  </div>
                  <div class="col-12 col-md-7">
                    <div class>
                      <vs-input
                        v-validate="'required'"
                        name="Payment Mode Name"
                        v-model="form.payment_mode_name"
                        class="w-full"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('Payment Mode Name')"
                        >{{ errors.first("Payment Mode Name") }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col mx-auto">
                <vs-button
                  :disabled="submitStatus"
                  type="filled"
                  @click.prevent="submitForm"
                  class="mr-3"
                >
                  Update
                </vs-button>
              </div>
            </div>
          </FocusLock>
        </form>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import { BASEURL, ORG_LOGO } from "@/config/index";
import MasterService from "@/services/MasterService.js";
export default Vue.extend({
  data() {
    return {
      ORG_LOGO,
      switch1: true,
      submitStatus: true,
      form: {
        payment_mode_name: "",
        payment_mode_icon: "",
        payment_mode_id: "",
        payment_mode_isActive: "1",
      },

      popupActive: false,
      params: null,
      value: null,
      count: 0,
    };
  },
  watch: {
    form: {
      handler: function(newVal, oldVal) {
        if (this.count > 0) {
          this.submitStatus = false;
        }
        this.count++;
      },
      deep: true,
    },
  },
  beforeMount() {
    this.value = this.params.value;
    this.form = this.params.data;
  },
  beforeDestroy() {
    let _id = document.getElementById(
      "popmodal" + this.params.data.payment_mode_id
    );
    _id.setAttribute("style", "display: none;");
  },
  methods: {
    showModal() {
      this.popupActive = true;
    },
    uploadFile(event) {
      let that = this;
      let formData = new FormData();
      let organization_id = window.localStorage.getItem("OrganizationID");
      formData.append("file[]", event.target.files[0]);
      axios
        .post(
          BASEURL + "/v2/multipleUploads?organization_id=" + organization_id,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              authorization: this.access_token,
            },
          }
        )
        .then(function(res) {
          that.form.payment_mode_icon = res.data.data.image_path;
        })
        .catch(function(err) {
          this.$vs.notify({
            title: "Error!",
            text: err.message,
            iconPack: "feather",
            icon: "check_box",
            color: "warning",
          });
        });
    },
    submitForm() {
      this.$validator.validateAll().then((result) => {
        this.$vs.loading();
        if (result) {
          this.submitStatus = true;
          let id = this.form.payment_mode_id;
          let payload = {
            payment_mode_name: this.form.payment_mode_name,
            payment_mode_id: this.form.payment_mode_id,
            payment_mode_icon: this.form.payment_mode_icon,
            payment_mode_isActive: this.params.data.payment_mode_isActive,
          };

          MasterService.updatePaymentMode(payload, id)
            .then((response) => {
              this.$vs.loading.close();
              this.submitStatus = false;
              const { data } = response;
              this.popupActive = false;
              if (data.Status == true || data.Status == "true") {
                this.$vs.notify({
                  title: "Updated!",
                  text: data.Message,
                  iconPack: "feather",
                  icon: "check_box",
                  color: "success",
                });
                setTimeout(() => {
                  eventBus.$emit("conrefreshTablePaymentModeType", data);
                }, 1);
                this.clearForm();
              } else {
                this.$vs.loading.close();
                this.$vs.notify({
                  title: "Error!",
                  text: data.Message,
                  iconPack: "feather",
                  icon: "check_box",
                  color: "warning",
                });
              }
            })
            .catch((error) => {
              this.$vs.loading.close();
              this.submitStatus = true;
            });
        }
      });
    },

    clearForm: function() {
      Object.keys(this.form).map((x, index) => {
        /_active/.test(x) ? (this.form[x] = "1") : (this.form[x] = "");
      });
      this.$validator.reset();
    },
  },
});
</script>
